import React from 'react';
import { Link } from 'react-router-dom';

const Bei = () => {
  // Section titles ke liye common style
  const sectionTitleStyle = {
      color: '#003366',
      borderBottom: '2px solid #003366',
      paddingBottom: '10px',
      marginBottom: '20px',
      fontSize: '18px',
      fontFamily: 'serif',
      textTransform: 'uppercase'
  };

  // Dummy news data (Aap isay backend se bhi la sakte hain)
  // Note: Aapko public/images folder mein ye images dalni hongi
  const newsItems = [
    {
      id: 1,
      // Apni image ka sahi naam yahan likhein
      image: '/images/20251229-1ES_5784.jpg',
      title: 'Danish Presidency of the Council of the EU has published the conclusions of the General Affairs Council: Moldova is appreciated and supported by its European partners',
      date: '17-12-2025 09:30',
      views: 104
    },
    {
      id: 2,
      image: '/images/20251229-1ES_4843.jpg',
      title: 'Next steps on Moldova\'s European agenda, discussed by Cristina Gherasimov with Marilena Raouna',
      date: '16-12-2025 19:00',
      views: 16
    },
    {
      id: 3,
      image: '/images/20251229-_ES29651.jpg',
      title: 'Germany is a reliable partner of the Republic of Moldova on its European path',
      date: '16-12-2025 17:15',
      views: 79
    }
  ];

  return (
    <div className="container mt-5 mb-5">
      <div className="row">

        {/* === LEFT COLUMN: BEI Sidebar Menu === */}
        <div className="col-lg-3 mb-4">
            <h4 style={sectionTitleStyle}>BEI</h4>
            <div className="list-group list-group-flush font-serif">
                {/* Active Item */}
                <Link to="/bei" className="list-group-item list-group-item-action text-primary fw-bold border-0 ps-0 bg-transparent">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Bureau for European Integration
                </Link>
                {/* Other Items */}
                {['BEI Team', 'First Intergovernmental Conference Republic of Moldova – EU', '2025 - 2029 National Programme for the Accession...', 'Enlargement Package EU - Republic of Moldova', '2025 Enlargement Package Recommendations', 'Info Centre', 'Explanatory screening'].map((item, index) => (
                    <a href="#" key={index} className="list-group-item list-group-item-action text-secondary border-0 ps-0 bg-transparent">
                        <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> {item}
                    </a>
                ))}
            </div>
        </div>

        {/* === CENTER COLUMN: News List === */}
        <div className="col-lg-6 mb-4">
            <h4 style={sectionTitleStyle}>EUROPEAN INTEGRATION OFFICE</h4>

            <div className="d-flex flex-column gap-4">
                {newsItems.map(item => (
                <div className="row g-0 border-bottom pb-4" key={item.id}>
                    <div className="col-md-5">
                        {/* Image */}
                        <img src={item.image} className="img-fluid rounded-start h-100" alt={item.title} style={{objectFit: 'cover', minHeight: '140px'}}/>
                    </div>
                    <div className="col-md-7 ps-md-3 pt-3 pt-md-0">
                        {/* Title */}
                        <h6 className="fw-bold mb-2" style={{fontFamily: 'serif', lineHeight: '1.4'}}>
                            <a href="#" className="text-decoration-none" style={{color: '#003366'}}>{item.title}</a>
                        </h6>
                        {/* Date and Views */}
                        <div className="text-muted small">
                            <i className="fa fa-calendar me-2"></i> {item.date}
                            <i className="fa fa-eye ms-3 me-2"></i> {item.views}
                        </div>
                    </div>
                </div>
                ))}
            </div>
        </div>

        {/* === RIGHT COLUMN: Agenda & Widget (Same as other pages) === */}
        <div className="col-lg-3">
            <h4 style={sectionTitleStyle}>AGENDA</h4>

            {/* Calendar Widget */}
            <div className="bg-white border rounded shadow-sm p-0 mb-4">
                <div className="d-flex justify-content-between align-items-center text-white p-2" style={{backgroundColor: '#003366'}}>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-left"></i></button>
                    <span className="fw-bold">January 2026</span>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-right"></i></button>
                </div>
                <div className="p-2">
                    <table className="table table-sm text-center border-0 mb-0" style={{fontSize: '12px'}}>
                        <thead>
                            <tr className="text-primary fw-bold">
                                <th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th><th>S</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td></td><td></td><td></td><td className="text-danger fw-bold border border-danger">1</td><td>2</td><td>3</td><td>4</td></tr>
                            <tr><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td></tr>
                            <tr><td>12</td><td>13</td><td>14</td><td>15</td><td>16</td><td>17</td><td>18</td></tr>
                            <tr><td>19</td><td>20</td><td>21</td><td>22</td><td>23</td><td>24</td><td>25</td></tr>
                            <tr><td>26</td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td></td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Blue Bubble Widget */}
            <div className="d-flex justify-content-end mt-5">
                <div className="position-relative text-end" style={{maxWidth:'200px'}}>
                    <div className="bg-primary text-white p-3 rounded shadow" style={{backgroundColor: '#336699 !important', fontSize:'12px'}}>
                         <div className="d-flex justify-content-between align-items-start mb-2">
                            <strong>EUROPA PENTRU TINE!</strong>
                            <i className="fa fa-times-circle opacity-50" style={{cursor:'pointer'}}></i>
                         </div>
                        Află despre beneficiile și oportunitățile oferite Republicii Moldova de Uniunea Europeană.
                    </div>
                    <div style={{
                        width: 0, height: 0,
                        borderLeft: '10px solid transparent',
                        borderRight: '10px solid transparent',
                        borderTop: '15px solid #0d6efd',
                        marginLeft: 'auto', marginRight: '20px'
                    }}></div>
                    <img src="/images/plan_eu.png" className="rounded-circle mt-2 shadow" width="60" alt="EU"/>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default Bei;